import { useRef } from "react";
import compressImage from "../utils/compressImage";

export default function PhotoUpload({ photos = [], onChange, max = 3 }) {
  const inputRef = useRef(null);

  const handleAdd = async (e) => {
    const files = Array.from(e.target.files || []);
    const remaining = max - photos.length;
    if (remaining <= 0) return;

    const toProcess = files.slice(0, remaining);
    const compressed = await Promise.all(toProcess.map((f) => compressImage(f)));
    onChange([...photos, ...compressed]);
    if (inputRef.current) inputRef.current.value = "";
  };

  const handleRemove = (index) => {
    onChange(photos.filter((_, i) => i !== index));
  };

  return (
    <div>
      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "8px" }}>
        {photos.map((src, i) => (
          <div key={i} style={{ position: "relative", width: "80px", height: "80px" }}>
            <img
              src={src}
              alt={`Foto ${i + 1}`}
              style={{
                width: "80px",
                height: "80px",
                objectFit: "cover",
                borderRadius: "8px",
                border: "2px solid #e8e0d4",
              }}
            />
            <button
              onClick={() => handleRemove(i)}
              style={{
                position: "absolute",
                top: "-6px",
                right: "-6px",
                width: "20px",
                height: "20px",
                borderRadius: "50%",
                border: "none",
                backgroundColor: "#e53e3e",
                color: "#fff",
                fontSize: "12px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                lineHeight: 1,
                padding: 0,
              }}
            >
              x
            </button>
          </div>
        ))}
      </div>
      {photos.length < max && (
        <label
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 16px",
            backgroundColor: "#fdfbf7",
            border: "2px dashed #e8e0d4",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "13px",
            fontFamily: "'DM Sans', sans-serif",
            color: "#4a3f35",
            fontWeight: 500,
          }}
        >
          + Adauga foto ({photos.length}/{max})
          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            multiple
            onChange={handleAdd}
            style={{ display: "none" }}
          />
        </label>
      )}
    </div>
  );
}
